window.__WWAI__ = window.__WWAI__ || {};
  
// Environment + Mode Config
// Use metafield-based subscription in sandbox/local
window.__WWAI__.useMockSubscription = true;

// Options: "local" | "sandbox" | "prod"
window.__WWAI__.deployMode = "prod";

// Enables dev/debugger mode, values are dev, prod
window.__WWAI__.MODE = "prod";

// Controls Liquid-product rendering
window.__WWAI__.RENDER_WITH_LIQUID = true;

// Which connector to use for hydration
window.__WWAI__.CONNECTOR_TYPE = "shopify";

// Enable logging for grid height debugging
window.__WWAI__.heightEqualizeLogging = true;

// Currency Config
// Active currency from Shopify
window.__WWAI__.CURRENCY = Shopify.currency.active;

// Currency conversion factor
window.__WWAI__.CURRENCY_FACTOR = 0.01;

// Product mapping object
window.__WWAI__.JS_PRODUCT_MAPPING_OBJECT = {
  "solid-surface-knife-magnet-5pc": {
    "solid-surface-knife-magnet-5pc": "solid-surface-knife-magnet-5pc"
  },
  "mise-magnet-3": {
    "mise-magnet-3": "mise-magnet-3"
  },
  "arete-knife-block-option-a": {
    "arete-knife-block-option-a": "arete-knife-block-option-a"
  },
  "2-5-bird-and-trout": {
    "2-5-bird-and-trout": "2-5-bird-and-trout"
  },
  "s7-throwing-tomahawk": {
    "s7-throwing-tomahawk": "s7-throwing-tomahawk"
  },
  "cleaver-hawk": {
    "cleaver-hawk": "cleaver-hawk"
  },
  "g-fusion-mini-masher": {
    "g-fusion-mini-masher": "g-fusion-mini-masher"
  },
  "turner-spatula": {
    "turner-spatula": "turner-spatula"
  },
  "g-fusion-slotted-fish-spatula": {
    "g-fusion-slotted-fish-spatula": "g-fusion-slotted-fish-spatula"
  },
  "carving-fork": {
    "carving-fork": "carving-fork"
  }
};

// Product group config
window.__WWAI__.WWAI_PRODUCT_GROUP_CONFIG = {
  "nwkw_nkd_grid_products_list_DmULXj": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true,
          "preInjectedMedia": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "nwkw",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "g-fusion-7-teton-edge-santoku": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-7-teton-edge-santoku",
        "defaultVariantOption1": "Huckleberry",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-7-teton-edge-santoku",
        "allOptions": {
          "option1": "Huckleberry | Cadet | Shoshone | Sunburst | Peacock | Lichen | Sherwood | Black | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-steak-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-steak-knife",
        "defaultVariantOption1": "Ironwood",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-steak-knife",
        "allOptions": {
          "option1": "Ironwood | Peacock | Lichen | Huckleberry | Cadet | Black | Sunburst | Shoshone",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-3-paring-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-3-paring-knife",
        "defaultVariantOption1": "Sunburst",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-3-paring-knife",
        "allOptions": {
          "option1": "Sunburst | Black | Cadet | Peacock | Shoshone | Lichen | Huckleberry | Sherwood | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "8-chef-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "8-chef-knife",
        "defaultVariantOption1": "Cadet",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "8-chef-knife",
        "allOptions": {
          "option1": "Cadet | Peacock | Huckleberry | Sunburst | Shoshone | Lichen | Sherwood | Black | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "tactical-outdoor-chef-1": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "tactical-outdoor-chef-1",
        "defaultVariantOption1": "The TOC",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "tactical-outdoor-chef-1",
        "allOptions": {
          "option1": "The TOC",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-5-chopper": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-5-chopper",
        "defaultVariantOption1": "Lichen",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-5-chopper",
        "allOptions": {
          "option1": "Lichen | Shoshone | Cadet | Sunburst | Huckleberry | Peacock | Black | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "4-outfitter": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "4-outfitter",
        "defaultVariantOption1": "Shoshone",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "4-outfitter",
        "allOptions": {
          "option1": "Shoshone | Sunburst | Lichen | Huckleberry | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-6-petty-utility-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-6-petty-utility-knife",
        "defaultVariantOption1": "Cadet",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-6-petty-utility-knife",
        "allOptions": {
          "option1": "Cadet | Sunburst | Peacock | Lichen | Huckleberry | Shoshone | Black | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_fmxAPg": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true,
          "preInjectedMedia": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "nwkw",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "g-fusion-steak-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-steak-knife",
        "defaultVariantOption1": "Ironwood",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-steak-knife",
        "allOptions": {
          "option1": "Ironwood | Peacock | Lichen | Huckleberry | Cadet | Black | Sunburst | Shoshone",
          "option2": "",
          "option3": ""
        }
      }
    },
    "build-your-steak-knife-set": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "build-your-steak-knife-set",
        "defaultVariantOption1": "default name",
        "defaultVariantOption2": "default items",
        "defaultVariantOption3": null,
        "allProducts": "build-your-steak-knife-set",
        "allOptions": {
          "option1": "default name",
          "option2": "default items",
          "option3": ""
        }
      }
    },
    "arete-steak-knife-block-g-fusion-1": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "arete-steak-knife-block-g-fusion-1",
        "defaultVariantOption1": "default name",
        "defaultVariantOption2": "default items",
        "defaultVariantOption3": null,
        "allProducts": "arete-steak-knife-block-g-fusion-1",
        "allOptions": {
          "option1": "default name",
          "option2": "default items",
          "option3": ""
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_cD9FLW": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true,
          "preInjectedMedia": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "nwkw",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "9-carving-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "9-carving-knife",
        "defaultVariantOption1": "Shoshone",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "9-carving-knife",
        "allOptions": {
          "option1": "Shoshone | Huckleberry | Black | Sunburst | Cadet | Peacock | Lichen | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-5-chopper": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-5-chopper",
        "defaultVariantOption1": "Lichen",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-5-chopper",
        "allOptions": {
          "option1": "Lichen | Shoshone | Cadet | Sunburst | Huckleberry | Peacock | Black | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "8-western-chef-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "8-western-chef-knife",
        "defaultVariantOption1": "Lichen",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "8-western-chef-knife",
        "allOptions": {
          "option1": "Lichen | Sunburst | Huckleberry | Peacock | Shoshone | Cadet | Black | Ironwood | Miyuki",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-9-superbread": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-9-superbread",
        "defaultVariantOption1": "Sherwood",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-9-superbread",
        "allOptions": {
          "option1": "Sherwood | Lichen | Huckleberry | Sunburst | Peacock | Cadet | Black | Shoshone | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-9-chef-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-9-chef-knife",
        "defaultVariantOption1": "Shoshone",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-9-chef-knife",
        "allOptions": {
          "option1": "Shoshone | Huckleberry | Lichen | Cadet | Peacock | Ironwood | Sunburst | Sherwood | Black",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-6-deli": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-6-deli",
        "defaultVariantOption1": "Peacock",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-6-deli",
        "allOptions": {
          "option1": "Peacock | Sunburst | Cadet | Shoshone | Lichen | Ironwood | Huckleberry | Black",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-6-petty-utility-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-6-petty-utility-knife",
        "defaultVariantOption1": "Cadet",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-6-petty-utility-knife",
        "allOptions": {
          "option1": "Cadet | Sunburst | Peacock | Lichen | Huckleberry | Shoshone | Black | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "chris-kidder-special-12-chef-knife": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "chris-kidder-special-12-chef-knife",
        "defaultVariantOption1": "Sunburst",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "chris-kidder-special-12-chef-knife",
        "allOptions": {
          "option1": "Sunburst | Sherwood | Shoshone | Lichen | Cadet | Peacock | Huckleberry | Black | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_XBF9Uk": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true,
          "preInjectedMedia": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "nwkw",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "jack-rellstab-nwkw-custom-6-damascus-chef-138": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "jack-rellstab-nwkw-custom-6-damascus-chef-138",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "jack-rellstab-nwkw-custom-6-damascus-chef-138",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "jack-rellstab-nwkw-custom-5-damascus-nakiri-135-copy": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "jack-rellstab-nwkw-custom-5-damascus-nakiri-135-copy",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "jack-rellstab-nwkw-custom-5-damascus-nakiri-135-copy",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "arik-miller-nwkw-custom-6-slim-witches-cleaver-031": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "arik-miller-nwkw-custom-6-slim-witches-cleaver-031",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "arik-miller-nwkw-custom-6-slim-witches-cleaver-031",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "arik-miller-nwkw-custom-7-damascus-witch-cleaver": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "arik-miller-nwkw-custom-7-damascus-witch-cleaver",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "arik-miller-nwkw-custom-7-damascus-witch-cleaver",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_N9hBBf": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true,
          "preInjectedMedia": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "nwkw",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "solid-surface-knife-magnet-5pc": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "solid-surface-knife-magnet-5pc",
        "defaultVariantOption1": "Slate",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "solid-surface-knife-magnet-5pc",
        "allOptions": {
          "option1": "Slate | Stone",
          "option2": "",
          "option3": ""
        }
      }
    },
    "mise-magnet-3": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "mise-magnet-3",
        "defaultVariantOption1": "Stone",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "mise-magnet-3",
        "allOptions": {
          "option1": "Stone | Slate",
          "option2": "",
          "option3": ""
        }
      }
    },
    "arete-knife-block-option-a": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "arete-knife-block-option-a",
        "defaultVariantOption1": "default name",
        "defaultVariantOption2": "default items",
        "defaultVariantOption3": null,
        "allProducts": "arete-knife-block-option-a",
        "allOptions": {
          "option1": "default name",
          "option2": "default items",
          "option3": ""
        }
      }
    },
    "arete-steak-knife-block-g-fusion-1": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "arete-steak-knife-block-g-fusion-1",
        "defaultVariantOption1": "default name",
        "defaultVariantOption2": "default items",
        "defaultVariantOption3": null,
        "allProducts": "arete-steak-knife-block-g-fusion-1",
        "allOptions": {
          "option1": "default name",
          "option2": "default items",
          "option3": ""
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_KBiACX": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true,
          "preInjectedMedia": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "nwkw",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "2-5-bird-and-trout": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "2-5-bird-and-trout",
        "defaultVariantOption1": "Huckleberry",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "2-5-bird-and-trout",
        "allOptions": {
          "option1": "Huckleberry | Sunburst | Shoshone | Lichen | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "4-outfitter": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "4-outfitter",
        "defaultVariantOption1": "Shoshone",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "4-outfitter",
        "allOptions": {
          "option1": "Shoshone | Sunburst | Lichen | Huckleberry | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "s7-throwing-tomahawk": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "s7-throwing-tomahawk",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "s7-throwing-tomahawk",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    },
    "cleaver-hawk": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "cleaver-hawk",
        "defaultVariantOption1": "Default Title",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "cleaver-hawk",
        "allOptions": {
          "option1": "Default Title",
          "option2": "",
          "option3": ""
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_AeKDaG": {
    "defaults": {
      "pricingConfig": {
        "discountPercent": 0,
        "subscriptionDiscountPercent": 0,
        "defaultSubscriptionOption": null,
        "useVariantCompareAtPriceForSubscription": true,
        "discountCodeToApply": [],
        "roundDiscount": true,
        "addOffSuffixToDiscount": false
      },
      "uxConfig": {
        "variantOptionRemovePrefix": "Every",
        "defaultPurchaseType": "onetime",
        "imageCarouselConfig": {
          "useCustomImages": true,
          "preInjectedMedia": true
        },
        "variantUXConfig": {
          "hideSingleLengthVariants": false,
          "onlyShowVariantsWithLabelContains": null,
          "refreshUxOnVariantChange": true
        },
        "preAddToCartFlowConfig": {
          "journeyType": "overlay",
          "overlayContents": [],
          "postSelectionAction": "na",
          "postSelectionActionParams": {
            "custom_url": null,
            "redirect_variant_options": null
          }
        }
      },
      "flowConfig": {
        "destination": "side-cart",
        "loader": "add-to-cart-submit-button",
        "showSuccessNotification": false,
        "showErrorNotification": false,
        "sideCartLabel": "nwkw",
        "successNotificationMessage": "✅ Added to cart!",
        "errorNotificationMessage": "Oops, couldn't add item.",
        "notificationOptions": {
          "backgroundColor": "#E8DDFA",
          "textColor": "#000000",
          "borderColor": "transparent",
          "fontFamily": "sans-serif"
        }
      }
    },
    "g-fusion-mini-masher": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-mini-masher",
        "defaultVariantOption1": "Lichen",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-mini-masher",
        "allOptions": {
          "option1": "Lichen | Cadet | Shoshone | Sunburst | Huckleberry | Peacock | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "turner-spatula": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "turner-spatula",
        "defaultVariantOption1": "Sunburst",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "turner-spatula",
        "allOptions": {
          "option1": "Sunburst | Peacock | Shoshone | Huckleberry | Cadet | Lichen | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "g-fusion-slotted-fish-spatula": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "g-fusion-slotted-fish-spatula",
        "defaultVariantOption1": "Huckleberry",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "g-fusion-slotted-fish-spatula",
        "allOptions": {
          "option1": "Huckleberry | Sunburst | Peacock | Shoshone | Lichen | Cadet | Ironwood",
          "option2": "",
          "option3": ""
        }
      }
    },
    "carving-fork": {
      "pricingConfig": null,
      "uxConfig": null,
      "flowConfig": null,
      "variantDispatchConfig": {
        "defaultProduct": "carving-fork",
        "defaultVariantOption1": "Sunburst",
        "defaultVariantOption2": null,
        "defaultVariantOption3": null,
        "allProducts": "carving-fork",
        "allOptions": {
          "option1": "Sunburst | Shoshone | Huckleberry | Black | Lichen | Peacock | Cadet | Ironwood | Miyuki",
          "option2": "",
          "option3": ""
        }
      }
    }
  }
};

// Variant overrides
window.__WWAI__.WWAI_PRODUCT_VARIANT_OVERRIDES = {
  "nwkw_nkd_grid_products_list_DmULXj": {
    "g-fusion-7-teton-edge-santoku": {
      "g-fusion-7-teton-edge-santoku": {
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sherwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-steak-knife": {
      "g-fusion-steak-knife": {
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-3-paring-knife": {
      "g-fusion-3-paring-knife": {
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sherwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "8-chef-knife": {
      "8-chef-knife": {
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sherwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "tactical-outdoor-chef-1": {
      "tactical-outdoor-chef-1": {
        "The TOC": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-5-chopper": {
      "g-fusion-5-chopper": {
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "4-outfitter": {
      "4-outfitter": {
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-6-petty-utility-knife": {
      "g-fusion-6-petty-utility-knife": {
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_fmxAPg": {
    "g-fusion-steak-knife": {
      "g-fusion-steak-knife": {
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "build-your-steak-knife-set": {
      "build-your-steak-knife-set": {
        "default name | default items": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "arete-steak-knife-block-g-fusion-1": {
      "arete-steak-knife-block-g-fusion-1": {
        "default name | default items": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_cD9FLW": {
    "9-carving-knife": {
      "9-carving-knife": {
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-5-chopper": {
      "g-fusion-5-chopper": {
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "8-western-chef-knife": {
      "8-western-chef-knife": {
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Miyuki": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-9-superbread": {
      "g-fusion-9-superbread": {
        "Sherwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-9-chef-knife": {
      "g-fusion-9-chef-knife": {
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sherwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-6-deli": {
      "g-fusion-6-deli": {
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-6-petty-utility-knife": {
      "g-fusion-6-petty-utility-knife": {
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "chris-kidder-special-12-chef-knife": {
      "chris-kidder-special-12-chef-knife": {
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sherwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_XBF9Uk": {
    "jack-rellstab-nwkw-custom-6-damascus-chef-138": {
      "jack-rellstab-nwkw-custom-6-damascus-chef-138": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "jack-rellstab-nwkw-custom-5-damascus-nakiri-135-copy": {
      "jack-rellstab-nwkw-custom-5-damascus-nakiri-135-copy": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "arik-miller-nwkw-custom-6-slim-witches-cleaver-031": {
      "arik-miller-nwkw-custom-6-slim-witches-cleaver-031": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "arik-miller-nwkw-custom-7-damascus-witch-cleaver": {
      "arik-miller-nwkw-custom-7-damascus-witch-cleaver": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_N9hBBf": {
    "solid-surface-knife-magnet-5pc": {
      "solid-surface-knife-magnet-5pc": {
        "Slate": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Stone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "mise-magnet-3": {
      "mise-magnet-3": {
        "Stone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Slate": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "arete-knife-block-option-a": {
      "arete-knife-block-option-a": {
        "default name | default items": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "arete-steak-knife-block-g-fusion-1": {
      "arete-steak-knife-block-g-fusion-1": {
        "default name | default items": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_KBiACX": {
    "2-5-bird-and-trout": {
      "2-5-bird-and-trout": {
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "4-outfitter": {
      "4-outfitter": {
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "s7-throwing-tomahawk": {
      "s7-throwing-tomahawk": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "cleaver-hawk": {
      "cleaver-hawk": {
        "Default Title": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  },
  "nwkw_nkd_grid_products_list_AeKDaG": {
    "g-fusion-mini-masher": {
      "g-fusion-mini-masher": {
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "turner-spatula": {
      "turner-spatula": {
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "g-fusion-slotted-fish-spatula": {
      "g-fusion-slotted-fish-spatula": {
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    },
    "carving-fork": {
      "carving-fork": {
        "Sunburst": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Shoshone": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Huckleberry": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Black": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Lichen": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Peacock": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Cadet": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Ironwood": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        },
        "Miyuki": {
          "customMediaLabel": null,
          "redirectToMediaIndex": null,
          "customLabelText": {}
        }
      }
    }
  }
};

// Labeled images
window.__WWAI__.WWAI_LABELED_IMAGES = {};

// Action buttons
window.__WWAI__.ACTION_BUTTONS = {};
